<template>
  <div :style="{ width: width }">
    <a-select
      class="tw-w-full"
      v-model="value"
      mode="multiple"
      :max-tag-count="1"
      :placeholder="isPlaceholder ? placeholder : ''"
      @change="changeValue"
      :filterable="true"
      :filter-by-label="true"
    >
      <a-select-option
        v-for="item in options"
        :value="item.branch_id"
        :key="item.branch_id"
        :label="item.prefix_code"
      >
        {{ item.prefix_code }}
      </a-select-option>
    </a-select>
  </div>
</template>

<script>
export default {
  name: "branchFilter",
  props: {
    isPlaceholder: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: "100%",
    },
  },
  data() {
    return {
      value: [],
      options: [],
      loading: false,
    };
  },
  created() {
    this.fetchBranch();
  },
  computed: {
    placeholder() {
      return this.$t("all");
    },
  },
  methods: {
    fetchBranch() {
      this.loading = true;
      this.$store
        .dispatch("auth/user/getBranchAssigned")
        .then((response) => {
          this.options = response.data;
          this.value.push(
            this.$store.state.authUser.user.default_branch.branch_id
          );
          this.changeValue();
        })
        .catch((error) => {
          this.notice({ type: "error", text: error.message });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    changeValue() {
      this.$emit("filter", this.value);
    },
    notice(not) {
      this.$Notice[not.type]({
        title: "EMPLOYEE",
        desc: not.text,
      });
    },
  },
};
</script>
<style lang="css" scoped>
.vue-treeselect__control {
  height: 34px !important;
}
</style>
